import { put, select, takeLatest } from 'redux-saga/effects';
import { selectScopedSiteID } from 'reduxStore/app/selectors';
import { innerRangeActions } from './slice';
import { accessWindowsActions } from 'reduxStore/accessWindows/slice';
import { settingsActions } from 'reduxStore/settings/slice';
import { Notification } from 'zComponents/atoms';

export function* triggerSync() {
	const superFetchModule = yield import('library/helpers/superFetch');
	const superFetch = superFetchModule.default;
	try {
		// Files this run's audit rows under the picked site; null keeps them org-wide.
		const siteID = yield select(selectScopedSiteID);
		const res = yield superFetch.post(`/innerRange/sync`, { siteID });
		if (res.statusCode === 200) {
			yield put(settingsActions.loadOrgSettings());
			yield put(accessWindowsActions.loadAccessWindows());
			// Links changed, so the unlinked TimePeriods behind 'Link IR TimePeriod' did too.
			yield put(accessWindowsActions.loadExternalTimePeriods());
			yield put(innerRangeActions.triggerSyncSuccess());
		} else {
			throw new Error(res.error);
		}
	} catch (error) {
		Notification('error', error.message || 'Failed to trigger Integriti sync.');
		yield put(innerRangeActions.triggerSyncError(error.message));
	}
}

export default function* innerRangeSagas() {
	yield takeLatest(innerRangeActions.triggerSync, triggerSync);
}
